// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#waiter-change-request[data-v-5bc29090]{max-width:800px;margin-left:auto;margin-right:auto}#waiter-change-request .box-header .title[data-v-5bc29090]{font-size:22px;font-weight:700}#waiter-change-request .box-header .spinner[data-v-5bc29090]{width:22px;height:22px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
